export default __webpack_public_path__ + "static/media/mobile12.538a79dc.jfif";